<!--
 * @Author: QWX
 * @Description:开票申请基本信息
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-08 14:42:55
-->
<template>
  <el-card >
    <div slot="header" class="">
      <span class="saas-card-header-name">开票申请基本信息 </span>
    </div>
    <div class="">
      <el-form
        ref="relateForm"
        label-position="right"
        :model="baseInfo"
        label-width="180px"
        :gutter="20"
        disabled
      >
        <el-row :gutter="20" >
          <el-col :span="24">
            <el-row :gutter="20" >
              <el-col :span="12">
                <el-form-item label="开票申请单编号:" prop="invoiceCode" >
                  <el-input disabled :value="baseInfo.invoiceCode" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采购单位联系人：" prop="contact" >
              <el-input disabled :value="baseInfo.contact" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采购单位联系电话:" prop="contactPhone" >
              <el-input disabled :value="baseInfo.contactPhone" >
                <el-select
                  disabled
                  slot="prepend"
                  :value="baseInfo.contactPhonePrefix"
                  style="width:88px"
                >
                  <!-- <el-option label="+86" value="86"></el-option> -->
                  <el-option
                    v-for="(item, index) in enums.phoneAreaCodeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >{{ item.label }}</el-option
                  >
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商名称：" prop="supplierName" >
              <el-input disabled :value="baseInfo.supplierName" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商编号：" prop="supplierCode" >
              <el-input disabled :value="baseInfo.supplierCode" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商联系人：" prop="supplierContact" >
              <el-input disabled :value="baseInfo.supplierContact" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import { enums } from '@/lib/enum'
export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      enums
    }
  }
}
</script>
